import { SortDirection } from "../../shared/entities/Sort";

export class ClientGroupRequest {
  page: number = 0;
  descending: SortDirection = SortDirection.Descending;
  sortColumn: string = "amount";
  pageSize: number = 50;
  id: number = 0;
  dateFrom: string = "";
  dateTo: string = "";
  filter: any = null;
  text: string | null = null;
  impid: null = null;
  actionsentid: null = null;
  reason: null = null;
  pagesize: number = 50;
}
